export default "__VITE_ASSET__fb8c93c5__"